import { API_ENDPOINTS } from "../config/constants";

export const getVehicleMakes = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.VEHICLE_MAKES, {
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch vehicle makes");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching vehicle makes:", error);
    throw error;
  }
};

// Admin functions
export const addVehicleMake = async (makeData) => {
  const response = await fetch(API_ENDPOINTS.VEHICLE_MAKES, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(makeData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.msg || "Failed to add vehicle make");
  }

  return response.json();
};

export const updateVehicleMake = async (makeId, makeData) => {
  const response = await fetch(`${API_ENDPOINTS.VEHICLE_MAKES}/${makeId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(makeData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.msg || "Failed to update vehicle make");
  }

  return response.json();
};

export const addVehicleModel = async (makeId, modelData) => {
  const response = await fetch(
    `${API_ENDPOINTS.VEHICLE_MAKES}/${makeId}/models`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(modelData),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.msg || "Failed to add vehicle model");
  }

  return response.json();
};

export const updateVehicleModel = async (makeId, modelId, modelData) => {
  const response = await fetch(
    `${API_ENDPOINTS.VEHICLE_MAKES}/${makeId}/models/${modelId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(modelData),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.msg || "Failed to update vehicle model");
  }

  return response.json();
};

export const deleteVehicleModel = async (makeId, modelId) => {
  const response = await fetch(
    `${API_ENDPOINTS.VEHICLE_MAKES}/${makeId}/models/${modelId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.msg || "Failed to delete vehicle model");
  }

  return response.json();
};
